import { createSlice } from '@reduxjs/toolkit';

const freeCheckboxSlice = createSlice({
    name: 'freeCheckbox',
    initialState: false,
    reducers: {
        setFreeCheckbox: (state, action) => action.payload,
    },
});

export const { setFreeCheckbox } = freeCheckboxSlice.actions;

export default freeCheckboxSlice.reducer;
